import { useModal } from "hooks/useModal"

import { memo, useCallback, useState } from "react"
import styled from "styled-components"
import { useAppDispatch } from "reducers/store"
import Heading from "components/Typography/Heading"
import { clearAccount } from "reducers/accounts/accounts-actions"
import ModalV2 from "components/EvtKit/modal/ModalV2"
import BodyText from "components/Typography/BodyText"
import AccountDetailsCards from "./AccountDetailsCards/AccountDetailsCards"
import BillingsTable from "./BillingsTable/BillingsTable"
import EventsChart from "./EventsChart/EventsChart"
import { getFirstDayOfMonth } from "utils/formatDate"

const ModalWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 28px 0px 24px;
  gap: 20px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const initialMonthDate: Date = getFirstDayOfMonth()

export const initialDebouncedFilters: App.BillingsDateFilter = {
  start: undefined,
  end: undefined
}

export const initialFilters: App.BillingsDateFilter = {
  ...initialDebouncedFilters
}

const AccountDetailsModal = () => {
  const appDispatch = useAppDispatch()

  const [filters, setFilters] = useState<App.BillingsDateFilter>(initialFilters)

  const [debouncedFilters, setDebouncedFilters] = useState<App.BillingsDateFilter>(initialDebouncedFilters)

  const [monthFilter, setMonthFilter] = useState<Date | undefined>(initialMonthDate)

  const [take, setTake] = useState<string>("10")

  const cleanState = useCallback(() => {
    setFilters(initialFilters)
    setDebouncedFilters(initialDebouncedFilters)
    setMonthFilter(initialMonthDate)
    setTake("10")
  }, [])

  const { isOpen, type, closeModal } = useModal()

  const handleCleanModalState = useCallback(() => {
    appDispatch(clearAccount())
    closeModal()
    cleanState()
  }, [closeModal])

  return (
    <ModalV2
      openModal={isOpen && type === "accountDetails"}
      closeModal={handleCleanModalState}
      size="1-lg"
      backToTop={true}
    >
      <ModalWrapper>
        <Container>
          <Heading variant="h4" color="primary-dark">
            Detalhes da conta
          </Heading>
          <Content>
            <BodyText size="medium" weight="bold" color="gray-dark">
              Visualize as principais informações financeiras e operacionais da conta, incluindo saldo, plano vigente,
              consumo de eventos e pendências de pagamento.
            </BodyText>
            <AccountDetailsCards />
            <EventsChart monthFilter={monthFilter} setMonthFilter={setMonthFilter} />
            <BillingsTable
              filters={filters}
              debouncedFilters={debouncedFilters}
              setFilters={setFilters}
              setDebouncedFilters={setDebouncedFilters}
              take={take}
              setTake={setTake}
            />
          </Content>
        </Container>
      </ModalWrapper>
    </ModalV2>
  )
}

export default memo(AccountDetailsModal)
